<ng-container *ifPlatform="'browser'">
  <div class="tabs" *ngIf="screenSize !== SCREEN_SIZE.MOBILE_ONLY">
    <ul class="nav nav-tabs" role="tablist">
      <li translate="details.overview" (click)="activeTab =overviewTab" [class.active]="(!activeTab && neighbourhood) || activeTab===overviewTab"
        *ngIf="neighbourhood" tabindex="0" role="tab" (keydown.enter)="activeTab =overviewTab"></li>
      <li translate="demographics.household-income.text" (click)="activeTab =householdIncomeTabContent" [class.active]="(!activeTab && !neighbourhood) || activeTab===householdIncomeTabContent"
        *ngIf="demographics.income" tabindex="0" role="tab" (keydown.enter)="activeTab =householdIncomeTabContent"></li>
      <li translate="demographics.education.text" (click)="activeTab =educationTab" [class.active]="activeTab===educationTab"
        *ngIf="demographics.education" tabindex="0" role="tab" (keydown.enter)="activeTab =educationTab"></li>
      <li translate="demographics.household-tenancy.text" (click)="activeTab =tenancyTab" [class.active]="activeTab===tenancyTab"
        *ngIf="demographics.housingTenancy" tabindex="0" role="tab" (keydown.enter)="activeTab =tenancyTab"></li>
    </ul>
    <ng-template #overviewTab>
      <ng-container *ngTemplateOutlet="overviewTabContent"></ng-container>
    </ng-template>
    <ng-template #householdIncomeTab>
      <ng-container *ngTemplateOutlet="householdIncomeTabContent"></ng-container>
    </ng-template>
    <ng-template #educationTab>
      <ng-container *ngTemplateOutlet="educationTabContent"></ng-container>
    </ng-template>
    <ng-template #tenancyTab>
      <app-demographic-item [demographics]="demographics" demographicType="tenancy" [maintainAspectRatio]="true" [screenSize]="screenSize"></app-demographic-item>
    </ng-template>
    <div class="tab-content">
      <ng-container *ngTemplateOutlet="activeTab||(neighbourhood ? overviewTabContent : householdIncomeTabContent)"></ng-container>
    </div>
  </div>
  <app-accordion *ngIf="screenSize === SCREEN_SIZE.MOBILE_ONLY" class="graphs" #accordion>
    <app-accordion-item [index]="0" [label]="'details.overview'" [textOnly]="false" *ngIf="neighbourhood">
      <ng-container *ngTemplateOutlet="overviewTabContent"></ng-container>
    </app-accordion-item>
    <app-accordion-item [index]="1" [label]="'demographics.household-income.text'" [textOnly]="false" *ngIf="demographics.income">
      <ng-container *ngTemplateOutlet="householdIncomeTabContent"></ng-container>
    </app-accordion-item>
    <app-accordion-item [index]="2" [label]="'demographics.education.text'" [textOnly]="false" *ngIf="demographics.education">
      <ng-container *ngTemplateOutlet="educationTabContent"></ng-container>
    </app-accordion-item>
    <app-accordion-item [index]="3" [label]="'demographics.household-tenancy.text'" [textOnly]="false" *ngIf="demographics.housingTenancy && hasChartJsLoaded">
      <app-demographic-item [demographics]="demographics" demographicType="tenancy" [maintainAspectRatio]="true" [screenSize]="screenSize"></app-demographic-item>
    </app-accordion-item>
  </app-accordion>
</ng-container>

<ng-template #overviewTabContent>
  <div class="is-flex" [class.is-flex-column]="screenSize === SCREEN_SIZE.MOBILE_ONLY" [class.top-margin]="screenSize >= SCREEN_SIZE.TABLET_LANDSCAPE_UP" role="tabpanel">
    <div class="is-flex is-flex-column neighbourhood-name">
      <h4>{{ neighbourhood.name }}</h4>
      <a [routerLink]="[neighbourhood.detailUrl]">
        <span class="top-margin">{{ 'details.learn-more' | translate }} &gt;</span>
      </a>
    </div>
    <div class="empty-column hide-on-mobile"></div>
    <p class="text-align-justified character-content" [class.top-margin]="screenSize === SCREEN_SIZE.MOBILE_ONLY">
      {{ screenSize === SCREEN_SIZE.MOBILE_ONLY ? neighbourhood.reducedCharacterMobile : neighbourhood.reducedCharacterDesktop }}
    </p>
  </div>
</ng-template>

<ng-template #householdIncomeTabContent>
  <div class="graph" role="tabpanel">
    <div class="graph-cell graph-cell-1">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center light-blue">
        <div class="title">{{demographics.income.householdIncome.text}}</div>
        <div class="description" translate="demographics.household-income.average-household-income"></div>
      </div>
    </div>
    <div class="graph-cell graph-cell-2">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center dark-blue ">
        <div class="title">{{demographics.income.individualIncome.text}}</div>
        <div class="description" translate="demographics.household-income.average-individual-income"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #educationTabContent>
  <div class="graph" role="tabpanel">
    <div class="graph-cell graph-cell-1">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center graph-round-sm dark-blue">
        <div class="title">{{demographics.education.highSchool.text}}</div>
      </div>
      <div class="description" translate="demographics.education.highschool-certificate"></div>
    </div>

    <div class="graph-cell graph-cell-2">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center graph-round-sm red">
        <div class="title">{{demographics.education.tradeCertificate.text}}</div>
      </div>
      <div class="description" translate="demographics.education.apprentice-certificate"></div>
    </div>

    <div class="graph-cell graph-cell-3">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center graph-round-sm light-blue">
        <div class="title">{{demographics.education.collegeCertificate.text}}</div>
      </div>
      <div class="description" translate="demographics.education.college-certificate"></div>
    </div>

    <div class="graph-cell graph-cell-4">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center graph-round-sm red">
        <div class="title">{{demographics.education.universityCertificate.text}}</div>
      </div>
      <div class="description" translate="demographics.education.university-certificate"></div>
    </div>


    <div class="graph-cell graph-cell-5">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center graph-round-sm light-blue">
        <div class="title">{{demographics.education.bachelorDegree.text}}</div>
      </div>
      <div class="description" translate="demographics.education.university-degree"></div>
    </div>

    <div class="graph-cell graph-cell-6">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center graph-round-sm dark-blue">
        <div class="title">{{demographics.education.mastersOrDoctorate.text}}</div>
      </div>
      <div class="description" translate="demographics.education.master-degree"></div>
    </div>

    <div class="graph-cell graph-cell-7">
      <div class="graph-round is-flex is-flex-column has-flex-align-center has-flex-content-center graph-round-sm dark-blue">
        <div class="title">{{demographics.education.noHighSchool.text}}</div>
      </div>
      <div class="description" translate="demographics.education.no-certificate"></div>
    </div>
  </div>
</ng-template>
